import { useCallback, useEffect, useMemo } from "react";
import { useQueryLoader, useRelayEnvironment } from "react-relay";
import { createOperationDescriptor, getRequest } from "relay-runtime";
import { previewWidgetTaskSingleMock } from "./previewWidgetTaskSingleMock";
import { WidgetTaskSingleMockPreviewQUERY } from "./WidgetTaskSingleMockPreview";
import {
  WidgetTaskSingleMockPreviewQuery,
  WidgetTaskSingleMockPreviewQuery$rawResponse,
} from "./__generated__/WidgetTaskSingleMockPreviewQuery.graphql";

export function useWidgetTaskSingleMockPreviewQueryLoader(storecastId: string) {
  const env = useRelayEnvironment();

  const vars = useMemo(
    () =>
      ({
        input: {
          taskId: "",
          grouping: "SECTION",
          sectionIds: [],
          teamIds: [],
          id: "",
          taskSingleSize: "TWO_X_ONE",
        },
        storecastId,
      }) as const,
    [storecastId]
  );

  const [queryRef, load] = useQueryLoader<WidgetTaskSingleMockPreviewQuery>(
    WidgetTaskSingleMockPreviewQUERY
  );

  const populateData = useCallback(() => {
    const req = getRequest(WidgetTaskSingleMockPreviewQUERY);
    const op = createOperationDescriptor(req, vars);
    const payload = {
      dashboard: {
        id: vars.storecastId,
        previewWidgetTaskSingle: previewWidgetTaskSingleMock,
      },
    } as WidgetTaskSingleMockPreviewQuery$rawResponse;
    env.commitPayload(op, payload);
    load(vars);
  }, [env, load, vars]);

  useEffect(() => populateData(), [populateData]);

  return queryRef;
}
